export const tituloPrincipal = "Acesse sua Conta";

export const Email = 'E-mail'

export const Senha = 'Senha';

export const BotaoEntrar = 'Entrar';

export const BotaoEntrarcontaGoogle = '  Entrar com Google';

export const BotaoEntrarContaFacebook = 'Entrar com Facebook'

export const BotaoEntrarContaLinkedin = 'Entrar com Linkedin'

export const esqueceuSenha = 'Esqueci minha senha';

export const naoTemConta = 'Não tem conta? Crie uma agora';